export const BRAND_STYLES = { SINGLE: 'single', TWO: 'two' };

export const ACCENT_MODES = { RECOMMENDED: 'recommended', CUSTOM: 'custom' };

export const BRAND_SHADES = [
  { value: 'light', label: 'Light' },
  { value: 'medium', label: 'Medium' },
  { value: 'dark', label: 'Dark' }
];

export const DEFAULT_BRAND_COLOR = 'myriad-blue';
export const DEFAULT_BRAND_SHADE = 'light';

// Hex literals mirror the 600/700/800 stops of the matching scale in tailwind.config.js
// (Myriad blue uses 500/600/700 so its "Light" shade is the stock Myriad look). The
// `primary` scale there is CSS-variable driven, so the values can't be read at runtime.
export const BRAND_COLORS = [
  {
    key: 'slate',
    label: 'Slate',
    shades: { light: '#535862', medium: '#414651', dark: '#252B37' },
    recommendedAccent: 'myriad-blue'
  },
  {
    key: 'myriad-blue',
    label: 'Myriad blue',
    shades: { light: '#0BA5EC', medium: '#0086C9', dark: '#026AA2' },
    recommendedAccent: 'moss'
  },
  {
    key: 'red',
    label: 'Red',
    shades: { light: '#D92D20', medium: '#B42318', dark: '#912018' },
    recommendedAccent: 'slate'
  },
  {
    key: 'orange',
    label: 'Orange',
    shades: { light: '#DC6803', medium: '#B54708', dark: '#93370D' },
    recommendedAccent: 'teal'
  },
  {
    key: 'green',
    label: 'Green',
    shades: { light: '#099250', medium: '#087443', dark: '#095C37' },
    recommendedAccent: 'gold'
  },
  {
    key: 'moss',
    label: 'Moss',
    shades: { light: '#4F7A21', medium: '#3F621A', dark: '#335015' },
    recommendedAccent: 'violet'
  },
  {
    key: 'lime',
    label: 'Lime',
    shades: { light: '#4CA30D', medium: '#3B7C0F', dark: '#326212' },
    recommendedAccent: 'purple'
  },
  {
    key: 'teal',
    label: 'Teal',
    shades: { light: '#0E9384', medium: '#107569', dark: '#125D56' },
    recommendedAccent: 'orange'
  },
  {
    key: 'cyan',
    label: 'Cyan',
    shades: { light: '#088AB2', medium: '#0E7090', dark: '#155B75' },
    recommendedAccent: 'rose'
  },
  {
    key: 'royal-blue',
    label: 'Royal blue',
    shades: { light: '#155EEF', medium: '#004EEB', dark: '#0040C1' },
    recommendedAccent: 'gold'
  },
  {
    key: 'violet',
    label: 'Violet',
    shades: { light: '#7839EE', medium: '#6927DA', dark: '#5720B7' },
    recommendedAccent: 'moss'
  },
  {
    key: 'purple',
    label: 'Purple',
    shades: { light: '#6938EF', medium: '#5925DC', dark: '#4A1FB8' },
    recommendedAccent: 'lime'
  },
  {
    key: 'fuchsia',
    label: 'Fuchsia',
    shades: { light: '#BA24D5', medium: '#9F1AB1', dark: '#821890' },
    recommendedAccent: 'teal'
  },
  {
    key: 'pink',
    label: 'Pink',
    shades: { light: '#DD2590', medium: '#C11574', dark: '#9E165F' },
    recommendedAccent: 'cyan'
  },
  {
    key: 'rose',
    label: 'Rose',
    shades: { light: '#E31B54', medium: '#C01048', dark: '#A11043' },
    recommendedAccent: 'teal'
  },
  {
    key: 'orange-dark',
    label: 'Orange dark',
    shades: { light: '#E62E05', medium: '#BC1B06', dark: '#97180C' },
    recommendedAccent: 'cyan'
  },
  {
    key: 'gold',
    label: 'Gold',
    shades: { light: '#CA8504', medium: '#A15C07', dark: '#854A0E' },
    recommendedAccent: 'royal-blue'
  }
];

export const BRAND_COLOR_MAP = Object.fromEntries(BRAND_COLORS.map((color) => [color.key, color]));

export const getBrandColor = (key) => BRAND_COLOR_MAP[key] || BRAND_COLOR_MAP[DEFAULT_BRAND_COLOR];

export const getBrandHex = (key, shade = DEFAULT_BRAND_SHADE) => {
  const color = getBrandColor(key);
  return color.shades[shade] || color.shades[DEFAULT_BRAND_SHADE];
};
